import polyline from 'google-polyline';
import { defaultLang } from '../config';
import { toEPSG4326, fromEPSG4326 } from 'ol/proj/epsg3857';
import urlSafePolyline from '../lib/url-safe-polyline';

const DATA_SEPERATOR = '___';
const PARAMS_SEPERATOR = '-';

const BRACKET_LEFT = '..'; // (
const BRACKET_RIGHT = '++'; // )

export const swap = (data) => {
	var ret = {};
	for (var key in data) {
		ret[data[key]] = key;
	}
	return ret;
};

function isNumber(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

function roundNumericValuesInArray(array, precision, callback) {
	var roundedArray = [];

	array.forEach(function round(elem) {
		if (isNumber(elem)) {
			roundedArray.push(parseFloat(elem).toFixed(precision));
		} else if (elem.constructor === Array) {
			var coordPair = roundNumericValuesInArray(elem, precision);

			if (typeof callback === 'function') {
				coordPair = callback(coordPair);
			}

			roundedArray.push(coordPair);
		} else {
			roundedArray.push(elem);
		}
	});

	return roundedArray;
}

//  layers: ['wmsLayer', 'photoLayer', 'wmsBWLayer'],

export const urlShortenMapLv = {
	c: 'mapCoords',
	z: 'mapZoom',
	f: 'features',
	fmob: 'featuresMobile',
	p: 'Point',
	l: 'Line',
	rl: 'RulerLine',
	pg: 'Polygon',
	mp: 'MultiPolygon',
	ls: 'LineString',
	w: 'waypoints',
	fotoradari: 'speedCameras',
	sastregumi: 'traffic',
	bl: 'baseLayers',
	tp7: 'topo75Layer',
	cl: 'wmsLayer',
	pl: 'photoLayer',
	melnbalta_karte: 'wmsBWLayer',
	topografiska_karte: 'topoLayer',
	vektoru_karte: 'vectorLayer',
	pazinojums: 'notification',
	s: 'search',
	bez_interesu_punktiem: 'poiLayer',
	nosaukumi: 'labelLayer',
	reljefs: 'lidarLayer',
	adm_iedal: 'admDivisionLayer',
	embed: 'embed',
};

export const urlShortenMapOther = {
	c: 'mapCoords',
	z: 'mapZoom',
	f: 'features',
	fmob: 'featuresMobile',
	p: 'Point',
	l: 'Line',
	rl: 'RulerLine',
	pg: 'Polygon',
	mp: 'MultiPolygon',
	ls: 'LineString',
	w: 'waypoints',
	speed_cameras: 'speedCameras',
	trafficjams: 'traffic',
	bl: 'baseLayers',
	cl: 'wmsLayer',
	pl: 'photoLayer',
	black_white_map: 'wmsBWLayer',
	topographic_map: 'topoLayer',
	vector_map: 'vectorLayer',
	pazinojums: 'notification',
	s: 'search',
	no_poi: 'poiLayer',
	labels: 'labelLayer',
	relief: 'lidarLayer',
	adm_division: 'admDivisionLayer',
	embed: 'embed',
};

export const getShortenMap = (activeLang) => {
	if (activeLang === 'lv') {
		return urlShortenMapLv;
	}

	return urlShortenMapOther;
};

const convertCoordsToWGS = ({x, y}) => {
	const [lon, lat] = toEPSG4326([parseFloat(x), parseFloat(y)]);

	return {lat, lon}
}

const convertCoordsToMercator = ({lat, lon}) => {
	const [x, y] = fromEPSG4326([lon, lat]);

	console.log(x, y)

	return {x, y}
}

const handleCoordinates = (part1, part2) => {
	let coord1 = parseFloat(part1);
	let coord2 = parseFloat(part2);

	if (coord1 > 500) {
		return [
			parseFloat(coord1.toFixed(2)),
			parseFloat(coord2.toFixed(2))
		]
	}

	const {x, y} = convertCoordsToMercator({lat: coord1, lon: coord2})

	return [
		parseFloat(x.toFixed(2)),
		parseFloat(y.toFixed(2))
	]
}

const urlShortenMap = getShortenMap(window.activeLang);

export const propsToUrl = function (props) {
	var strURL = '/' + window.activeLang;

	var urlShortenMapRev = swap(urlShortenMap);

	for (var key in props) {
		if (key === 'routingProfile') {
			continue;
		}
		if (typeof props[key] === 'undefined' || (typeof props[key] === 'object' && props[key].length === 0)) {
			continue;
		}

		switch (key) {
			case 'baseLayers':
				strURL += '/bl' + DATA_SEPERATOR + urlShortenMapRev[props[key]];

				break;
			case 'labelLayer':
				if (props[key]) {
					strURL += '/' + urlShortenMapRev[key];
				}

				break;
			case 'poiLayer':
				if (!props[key]) {
					strURL += '/' + urlShortenMapRev[key];
				}

				break;
			case 'admDivisionLayer':
				if (props[key]) {
					strURL += '/' + urlShortenMapRev[key];
				}

				break;
			case 'notification':
				strURL += '/pazinojums';
				break;
			case 'embed':
			case 'speedCameras':
			case 'traffic':
				if (props[key]) {
					strURL += '/' + urlShortenMapRev[key] + DATA_SEPERATOR;
				}

				break;
			case 'waypoints':
				strURL += '/' + urlShortenMapRev[key] + DATA_SEPERATOR + (props.routingProfile || '') + '-';
				for (var i = 0, len = props[key].length; i < len; i++) {
					var {lon, lat} = convertCoordsToWGS({x: props[key][i].coords[0], y: props[key][i].coords[1]});

					strURL += `${lat.toFixed(6)},${lon.toFixed(6)},`;
				}
				strURL = strURL.slice(0, -1);

				break;
			case 'mapCoords':
				var {lon, lat} = convertCoordsToWGS({x: props[key][0], y: props[key][1]});
				strURL += `/c${DATA_SEPERATOR}${lat.toFixed(6)}-${lon.toFixed(6)}`;
				break;
			case 'mapZoom':
				strURL += '-' + parseInt(props[key]);
				break;
			case 'features':
				if (typeof props[key] === 'undefined') {
					continue;
				}

				var features = props[key];

				strURL += '/f' + DATA_SEPERATOR;

				for (var i = features.length - 1; i >= 0; i--) {
					if (features[i].geometry.type == 'GeometryCollection') {
						continue;
					}

					var geomCoords = features[i].geometry.coordinates;

					if (features[i].geometry.type === 'Polygon') {
						geomCoords = geomCoords[0];
					} else if (features[i].geometry.type === 'Point') {
						geomCoords = [geomCoords];
					}

					//google polyline works only in EPSG 4326
					var roundedCoords = roundNumericValuesInArray(geomCoords, 0, (coordPair) => {
						return toEPSG4326(coordPair);
					});

					var coordString = urlSafePolyline.encode(roundedCoords);

					strURL += '' + urlShortenMapRev[features[i].geometry.type] + '-' + coordString + '-';
					//	strURL += '' + urlShortenMapRev[features[i].geometry.type] + '-' + roundNumericValuesInArray(features[i].geometry.coordinates, 2) + '-';
				}

				strURL = strURL.substring(0, strURL.length - 1);
				//break;

				//featuresMobile start

				if (features.length !== 1 || features[0].geometry.type !== 'Point') {
					break;
				}

				strURL += '/fmob' + DATA_SEPERATOR;

				for (var i = features.length - 1; i >= 0; i--) {
					if (features[i].geometry.type !== 'Point') {
						continue;
					}

					var geomCoords = [features[i].geometry.coordinates];

					strURL +=
						'' +
						urlShortenMapRev[features[i].geometry.type] +
						'-' +
						roundNumericValuesInArray(features[i].geometry.coordinates, 2) +
						'-';
					//	strURL += '' + urlShortenMapRev[features[i].geometry.type] + '-' + roundNumericValuesInArray(features[i].geometry.coordinates, 2) + '-';
				}

				strURL = strURL.substring(0, strURL.length - 1);
				//featuresMobile end
				break;
			case 'search':
				var {lon, lat} = convertCoordsToWGS({x: props[key][0], y: props[key][1]});
				strURL += `/s${DATA_SEPERATOR}${lat.toFixed(6)}-${lon.toFixed(6)}`;
				break;
		}
	}

	strURL = strURL.replace(/\(/g, BRACKET_LEFT);
	strURL = strURL.replace(/\)/g, BRACKET_RIGHT);

	return strURL;
};

export const urlToProps = function (url) {
	var paramMap = swap(urlShortenMap);

	var props = {};

	url = url.replace(/\/(c|bl)_{1,2}([^_])/g, '/$1___$2');

	if (url.indexOf('f_p') > -1 || url.indexOf('f_pg') > -1 || url.indexOf('f_ls') > -1) {
		url = url.replace('/f_', '/fold___');
	}

	if (url.indexOf('f__p') > -1 || url.indexOf('f__pg') > -1 || url.indexOf('f__ls') > -1) {
		url = url.replace('/f__', '/fgp___'); //feature google polyline
	}

	url = url.replace(/[^_]__[^_]/g, '___');

	url = url.replace(/\.\./g, '(');
	url = url.replace(/\+\+/g, ')');

	var sections = url.split('/');

	for (var i = sections.length - 1; i >= 0; i--) {
		if (sections[i] == '') {
			continue;
		}

		if (sections[i].indexOf(DATA_SEPERATOR) > -1) {
			var indexTypeEnd = sections[i].indexOf(DATA_SEPERATOR);
			var sectionType = sections[i].substring(0, indexTypeEnd);

			var params = sections[i].slice(indexTypeEnd + DATA_SEPERATOR.length).split('-');
		} else {
			var sectionType = sections[i];
		}

		switch (sectionType) {
			case paramMap['embed']:
				props['embed'] = true;
				break;
			case paramMap['poiLayer']:
				props['poiLayer'] = true;
				break;
			case paramMap['labelLayer']:
				props['labelLayer'] = true;
				break;
			case paramMap['lidarLayer']:
				props['lidarLayer'] =  true;
				break;
			case paramMap['admDivisionLayer']:
				props['admDivisionLayer'] = true;
				break;
			case paramMap['baseLayers']:
				props['baseLayers'] = urlShortenMap[params[0]];
				break;
			case paramMap['notification']:
				props['notification'] = true;
				break;
			case paramMap['speedCameras']:
			case paramMap['traffic']:
				props[urlShortenMap[sectionType]] = true;

				break;
			case paramMap['mapCoords']:
				props['mapCoords'] = handleCoordinates(params[0], params[1]);
				props['mapZoom'] = parseInt(params[2]);

				break;
			case paramMap['search']:
				props['search'] = handleCoordinates(params[0], params[1]);
				break;
			case paramMap['waypoints']:
				var profile = params[0];
				var coords = params[1].split(',');
				var coordsArr = [];
				for (var c = 0, lenc = coords.length; c < lenc; c += 2) {
					coordsArr.push([...handleCoordinates(coords[c], coords[c + 1])]);
				}
				props['waypoints'] = coordsArr;
				props['routingProfile'] = profile;
				break;
			case 'fold': //backwars compability for old feature links / from old balticmaps
				//	var indexTypeEnd = sections[i].indexOf( '_' );
				//	var params = sections[i].slice(indexTypeEnd+'_'.length ).split('-');

				props['features'] = [];

				for (var n = 0, len2 = params.length; n < len2; n += 2) {
					var feature = false;

					switch (params[n]) {
						case 'p':
							feature = {
								type: 'Feature',
								geometry: {
									type: urlShortenMap[params[n]],
									coordinates: params[n + 1].split(','),
								},
							};

							break;
						case 'ls':
						case 'pg':
							//"f_ls-2704758.65,7735125.34,2701242.54,7737479.60,2702434.96,7740200.75-p-2696019.98,7745778.75-p-2693415.39,7744511.80"
							var coords = params[n + 1].split(',');
							var coordsArr = [];
							for (var c = 0, lenc = coords.length; c < lenc; c += 2) {
								coordsArr.push([
									parseFloat(parseFloat(coords[c]).toFixed(2)),
									parseFloat(parseFloat(coords[c + 1]).toFixed(2)),
								]);
							}

							if (params[n] == 'pg') {
								coordsArr = [coordsArr];
							}

							feature = {
								type: 'Feature',
								geometry: {
									type: urlShortenMap[params[n]],
									coordinates: coordsArr,
								},
							};

							break;
					}

					if (feature) {
						props['features'].push(feature);
					}
				}
				break;
			case 'fgp': //backwards compability for Google polyline-encoded feature links
				props['features'] = [];

				for (var n = 0, len2 = params.length; n < len2; n += 2) {
					var feature = false;

					switch (params[n]) {
						case 'p':
							var decoded = polyline.decode(decodeURIComponent(params[n + 1]));

							var coords = fromEPSG4326(decoded[0]);

							feature = {
								type: 'Feature',
								geometry: {
									type: urlShortenMap[params[n]],
									coordinates: coords,
								},
							};

							break;
						case 'ls':
						case 'pg':
							//"f_ls-2704758.65,7735125.34,2701242.54,7737479.60,2702434.96,7740200.75-p-2696019.98,7745778.75-p-2693415.39,7744511.80"
							//	var coords = params[n+1].split(',');

							var coordsArr = polyline.decode(decodeURIComponent(params[n + 1]));

							var coordsArrConverted = [];

							for (var ii = coordsArr.length - 1; ii >= 0; ii--) {
								coordsArrConverted.push(fromEPSG4326(coordsArr[ii]));
							}

							if (params[n] == 'pg') {
								coordsArrConverted = [coordsArrConverted];
							}

							feature = {
								type: 'Feature',
								geometry: {
									type: urlShortenMap[params[n]],
									coordinates: coordsArrConverted,
								},
							};

							break;
					}

					if (feature) {
						props['features'].push(feature);
					}
				}
				break;
			case paramMap['features']:
				props['features'] = [];

				for (var n = 0, len2 = params.length; n < len2; n += 2) {
					var feature = false;

					switch (params[n]) {
						case 'p':
							var decoded = urlSafePolyline.decode(decodeURIComponent(params[n + 1]));

							var coords = fromEPSG4326(decoded[0]);

							feature = {
								type: 'Feature',
								geometry: {
									type: urlShortenMap[params[n]],
									coordinates: coords,
								},
							};

							break;
						case 'ls':
						case 'pg':
							//"f_ls-2704758.65,7735125.34,2701242.54,7737479.60,2702434.96,7740200.75-p-2696019.98,7745778.75-p-2693415.39,7744511.80"
							//	var coords = params[n+1].split(',');

							var coordsArr = urlSafePolyline.decode(decodeURIComponent(params[n + 1]));

							var coordsArrConverted = [];

							for (var ii = coordsArr.length - 1; ii >= 0; ii--) {
								coordsArrConverted.push(fromEPSG4326(coordsArr[ii]));
							}

							if (params[n] == 'pg') {
								coordsArrConverted = [coordsArrConverted];
							}

							feature = {
								type: 'Feature',
								geometry: {
									type: urlShortenMap[params[n]],
									coordinates: coordsArrConverted,
								},
							};

							break;
					}

					if (feature) {
						props['features'].push(feature);
					}
				}

				break;
		}
	}

	return props;
};



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/urlRouting/urlParser.js